import { render, staticRenderFns } from "./salarydetails.vue?vue&type=template&id=7445c448&scoped=true&"
import script from "./salarydetails.vue?vue&type=script&lang=js&"
export * from "./salarydetails.vue?vue&type=script&lang=js&"
import style0 from "./salarydetails.vue?vue&type=style&index=0&id=7445c448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445c448",
  null
  
)

export default component.exports